import React from 'react';
import classnames from 'classnames';
var TextDivider = function(param) {
    var children = param.children, isSecondary = param.isSecondary, isComplete = param.isComplete, isMarginLess = param.isMarginLess;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('TextDivider', {
            secondary: isSecondary,
            complete: isComplete,
            'is-marginless': isMarginLess
        })
    }, children);
};
export default TextDivider;
